module.exports = __webpack_public_path__ + "img/zgh-2.180a7c4e.png";